import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X, Megaphone } from 'lucide-react';
import { API } from '@/App';

const DynamicBanner = ({ page = 'home' }) => {
  const [banners, setBanners] = useState([]);
  const [closedBanners, setClosedBanners] = useState([]);

  useEffect(() => {
    loadBanners();
    // Load closed banners from localStorage
    const closed = JSON.parse(localStorage.getItem('closedBanners') || '[]');
    setClosedBanners(closed);
  }, [page]);

  const loadBanners = async () => {
    try {
      const response = await axios.get(`${API}/banners/active`, {
        params: { page }
      });
      setBanners(response.data);
    } catch (error) {
      console.error('Error loading banners:', error);
    }
  };

  const handleClose = (bannerId) => {
    const updatedClosed = [...closedBanners, bannerId];
    setClosedBanners(updatedClosed);
    localStorage.setItem('closedBanners', JSON.stringify(updatedClosed));
  };

  const visibleBanners = banners.filter(banner => !closedBanners.includes(banner.id));

  if (visibleBanners.length === 0) return null;

  return (
    <div className="banner-container">
      {visibleBanners.map((banner) => (
        <div
          key={banner.id}
          className="relative animate-in slide-in-from-top duration-500"
          style={{
            backgroundColor: banner.background_color,
            color: banner.text_color
          }}
        >
          <div className="container mx-auto px-4 py-3">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 flex-1">
                <Megaphone className="w-5 h-5 flex-shrink-0" />
                <p className="text-sm md:text-base font-medium text-center md:text-left flex-1">
                  {banner.message}
                </p>
              </div>
              <button
                onClick={() => handleClose(banner.id)}
                className="p-1 hover:opacity-75 transition-opacity flex-shrink-0"
                aria-label="Fermer"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DynamicBanner;
